module.exports = __webpack_public_path__ + "img/icon-call.e64b8ec9.svg";